<template>
    <div class="form">
        <div id="page-title-area" class="main_visual">
            <div id="page-title-box">
                <h1>Contact Us</h1>
                <p>お問い合わせ</p>
                <div class="title-sq"></div>
            </div>
        </div>
        <div id="entry-form">
            <h2>お問い合わせを受け付けました</h2>
            <div class="table-display-area-border"></div>

            <p>
                この度は、お問い合わせ頂きありがとうございました。
                後日担当より、入力していただいた連絡先宛にご連絡させていただきます。
                ご入力していただいた内容に関してはメールアドレスに送らせていただきましたので、そちらをご確認ください。<br>
                尚、1週間以上経過しても連絡がない場合はお手数ですが、お問い合わせフォームより再度ご連絡ください。
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Complete"
    }
</script>

<style scoped>
    @import "../../assets/css/form.css";
    @import "../../assets/css/complete.css";
</style>